var _defs, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_357_97109",
    x1: -1.49435e-7,
    y1: 35.76,
    x2: 49.4435,
    y2: 31.3673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#048467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#064871"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.863 3.44312C22.5463 1.59557 25.4537 1.59557 27.137 3.44312C28.2537 4.66874 29.9818 5.1318 31.5617 4.62871C33.9433 3.87033 36.4612 5.32405 36.9952 7.76573C37.3494 9.38547 38.6145 10.6506 40.2343 11.0048C42.6759 11.5388 44.1297 14.0567 43.3713 16.4383C42.8682 18.0182 43.3313 19.7463 44.5569 20.863C46.4044 22.5463 46.4044 25.4537 44.5569 27.137C43.3313 28.2537 42.8682 29.9818 43.3713 31.5617C44.1297 33.9433 42.6759 36.4612 40.2343 36.9952C38.6145 37.3494 37.3494 38.6145 36.9952 40.2343C36.4612 42.6759 33.9433 44.1297 31.5617 43.3713C29.9818 42.8682 28.2537 43.3313 27.137 44.5569C25.4537 46.4044 22.5463 46.4044 20.863 44.5569C19.7463 43.3313 18.0182 42.8682 16.4383 43.3713C14.0567 44.1297 11.5388 42.6759 11.0048 40.2343C10.6506 38.6145 9.38547 37.3494 7.76573 36.9952C5.32405 36.4612 3.87033 33.9433 4.62871 31.5617C5.1318 29.9818 4.66874 28.2537 3.44312 27.137C1.59557 25.4537 1.59557 22.5463 3.44312 20.863C4.66874 19.7463 5.1318 18.0182 4.62871 16.4383C3.87033 14.0567 5.32405 11.5388 7.76573 11.0048C9.38547 10.6506 10.6506 9.38547 11.0048 7.76573C11.5388 5.32405 14.0567 3.87033 16.4383 4.62871C18.0182 5.1318 19.7463 4.66874 20.863 3.44312Z",
    fill: "url(#paint0_linear_357_97109)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 24,
    cy: 24,
    r: 16.9263,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.292 18.4409C18.6359 18.3955 21.6827 17.1197 24 15.0457C26.3173 17.1197 29.3641 18.3955 32.708 18.4409C32.8294 19.1643 32.8926 19.9074 32.8926 20.6653C32.8926 26.4732 29.1808 31.4141 24 33.2452C18.8192 31.4141 15.1074 26.4732 15.1074 20.6653C15.1074 19.9074 15.1706 19.1643 15.292 18.4409ZM28.1207 22.5629C28.5548 22.1288 28.5548 21.425 28.1207 20.9909C27.6866 20.5568 26.9828 20.5568 26.5487 20.9909L22.8884 24.6512L21.4513 23.214C21.0172 22.7799 20.3133 22.7799 19.8793 23.214C19.4452 23.6481 19.4452 24.3519 19.8793 24.786L22.1024 27.0092C22.5365 27.4433 23.2403 27.4433 23.6744 27.0092L28.1207 22.5629Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityBadge);
export default __webpack_public_path__ + "static/media/security-badge.e564014624b851191d5fd656f9923a0d.svg";
export { ForwardRef as ReactComponent };